import React from 'react'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import Story from '../Components/Story'

const OurStory = () => {
    return (
        <>
        <Navbar/>
        <Story/>
        <Footer/>
        </>
    )
}

export default OurStory
